var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHomeActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "745E462C-0A0C-4608-935E-6B199EAE2B40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_With-text",
    transform: "translate(-1081.000000, -166.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1071.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1941392,13.0485534 C39.1934525,13.0478668 39.1927658,13.0471802 39.192079,13.0464935 L26.953206,0.809326172 C26.4315311,0.287475586 25.7379484,0 25.000187,0 C24.2624256,0 23.5688429,0.287246719 23.0469391,0.809097305 L10.8144755,13.0400848 C10.8103551,13.0442047 10.8062348,13.0485534 10.8021145,13.0526733 C9.73083832,14.1300202 9.73266957,15.8779907 10.8073794,16.952591 C11.298381,17.4437713 11.9468693,17.7282715 12.6402231,17.7580261 C12.6683784,17.7607727 12.6967627,17.762146 12.7253758,17.762146 L13.2131728,17.762146 L13.2131728,26.7679596 C13.2131728,28.5500336 14.6632871,30 16.4460006,30 L21.2342391,30 C21.7195181,30 22.113235,29.6065521 22.113235,29.1210938 L22.113235,22.0605469 C22.113235,21.2473297 22.7747709,20.5858612 23.588071,20.5858612 L26.4123031,20.5858612 C27.2256031,20.5858612 27.8871391,21.2473297 27.8871391,22.0605469 L27.8871391,29.1210938 C27.8871391,29.6065521 28.2806271,30 28.766135,30 L33.5543735,30 C35.337087,30 36.7872013,28.5500336 36.7872013,26.7679596 L36.7872013,17.762146 L37.2395179,17.762146 C37.9770504,17.762146 38.6706331,17.4748993 39.1927658,16.9530487 C40.2686201,15.8766175 40.2690779,14.1256714 39.1941392,13.0485534 L39.1941392,13.0485534 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeActive);
export default __webpack_public_path__ + "static/media/ic_home_active.36c27b47c7ee721e9ef02b8b73c15488.svg";
export { ForwardRef as ReactComponent };